webpackJsonp([1],{

/***/ "/2az":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.common = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _ArticleView = __webpack_require__("ge7T");

var _ArticleView2 = _interopRequireDefault(_ArticleView);

var _Header = __webpack_require__("Jmag");

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__("DfMX");

var _Footer2 = _interopRequireDefault(_Footer);

var _Capsule = __webpack_require__("lyGB");

var _Capsule2 = _interopRequireDefault(_Capsule);

var _Loader = __webpack_require__("D0ZT");

var _Loader2 = _interopRequireDefault(_Loader);

var _MenuMobile = __webpack_require__("Io8Y");

var _MenuMobile2 = _interopRequireDefault(_MenuMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Common
*/

var common = {
  ArticleView: _vue2.default.component('article-view', _ArticleView2.default),
  HeaderComp: _vue2.default.component('header-comp', _Header2.default),
  FooterComp: _vue2.default.component('footer-comp', _Footer2.default),
  CapsuleArticle: _vue2.default.component('capsule-article', _Capsule2.default),
  Loader: _vue2.default.component('loader', _Loader2.default),
  MenuMobile: _vue2.default.component('menu-mobile', _MenuMobile2.default)
};

exports.common = common;

/***/ }),

/***/ "/5kN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn",
      "mode": "out-in"
    }
  }, [(_vm.contentData) ? _c('div', {
    key: _vm.dataReady,
    staticClass: "home-content__container"
  }, [_c('article-view', {
    attrs: {
      "content-data": _vm.contentData
    }
  }), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/nV0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _contentType = __webpack_require__("y+r/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = {
	routes: null,
	ids: []
};

var _routes = [];

for (var key in wp.routes) {
	var route = wp.routes[key];
	var component = void 0;

	if (route.type === 'post') {
		component = _contentType.contentType.PostType;
	} else {
		component = _contentType.contentType.PageType;
	}

	if (wp.base_url.indexOf(route.slug) > -1) {
		component = _contentType.contentType.Home;
	}

	if (route.slug === 'contact') {
		component = _contentType.contentType.Contact;
	}

	var objRoute = {
		path: '' + wp.base_path + route.slug,
		name: route.slug,
		component: component,
		meta: {
			title: route.slug.split(' ').map(function (s) {
				return s.charAt(0).toUpperCase() + s.slice(1);
			}).join(' '),
			analytics: {
				pageviewTemplate: function pageviewTemplate(route) {
					return {
						title: route.slug.split(' ').map(function (s) {
							return s.charAt(0).toUpperCase() + s.slice(1);
						}).join(' '),
						path: route.path,
						location: wp.base_path
					};
				}
			}
		}
	};

	router.ids.push({
		slug: route.slug,
		id: route.id,
		type: route.type
	});

	_routes.push(objRoute);
}

_routes.push({
	path: '/',
	name: 'home',
	component: _contentType.contentType.Home,
	meta: {
		title: 'Home',
		analytics: {
			pageviewTemplate: function pageviewTemplate(route) {
				return {
					title: 'Home',
					path: route.path,
					location: wp.base_path
				};
			}
		}
	}
});

router.routes = new _vueRouter2.default({
	mode: 'history',
	routes: _routes
});

exports.default = router;

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0Y1p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _selectParent = __webpack_require__("XhHI");

var _selectParent2 = _interopRequireDefault(_selectParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		this.checkPath('init');

		return {
			isHome: this.initIsHome,
			niv1Target: null,
			niv1Path: this.initNiv1Path
		};
	},

	methods: {
		setHover: function setHover(e) {
			var parent = (0, _selectParent2.default)('.li-niv-1', e.target);
			var el = void 0;

			if (parent) {
				el = parent;
			} else {
				el = e.target;
			}

			this.niv1Target = parseInt(el.getAttribute('data-index'));
		},
		resetHover: function resetHover() {
			this.niv1Target = null;
		},

		/*
  * Check if menu is active
  */
		checkPath: function checkPath(init) {
			var _this = this;

			_lodash2.default.find(this.$store.getters.getMenuData.body.items, function (item, index) {
				if (_this.$route.path.indexOf(item.object_slug) > -1) {
					if (init === 'init') {
						_this.initNiv1Path = index + 1;
					} else {
						_this.niv1Path = index + 1;
					}

					return true;
				}

				return null;
			});

			if (init === 'init') {
				this.initIsHome = this.$route.path === '/';
			} else {
				this.isHome = this.$route.path === '/';

				if (this.$route.path === '/') {
					this.niv1Path = null;
				}
			}
		}
	},
	watch: {
		'$route': 'checkPath'
	},
	computed: {
		getMenuData: function getMenuData() {
			return this.$store.getters.getMenuData;
		},
		getPostCategory: function getPostCategory() {
			return this.$store.getters.getPostCategory;
		}
	}
};

/***/ }),

/***/ "34s1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__("t4rm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a16bcd06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__("ManY");
function injectStyle (ssrContext) {
  __webpack_require__("iQp6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a16bcd06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3heq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Initial state
 */
var state = {
	routesId: null,
	routeLeave: false,
	pageTitle: wp.site_name + " - " + wp.site_name

	/**
  * Getters
  */
};var getters = {
	getRoutesId: function getRoutesId(state) {
		return state.routesId;
	},
	getRouteLeave: function getRouteLeave(state) {
		return state.routeLeave;
	},
	getPageTitle: function getPageTitle(state) {
		return state.pageTitle;
	}

	/**
  * Actions
  */
};var actions = {};

/**
 * Mutations
 */
var mutations = {
	setRoutesId: function setRoutesId(state, payload) {
		state.routesId = payload;
	},
	setRouteLeave: function setRouteLeave(state, payload) {
		state.routeLeave = payload;
	},
	setPageTitle: function setPageTitle(state, payload) {
		state.pageTitle = payload;
	}
};

module.exports = {
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
};

/***/ }),

/***/ "45KX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4waZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn",
      "mode": "out-in"
    }
  }, [(_vm.dataReady) ? _c('div', {
    key: _vm.dataReady,
    staticClass: "app-content"
  }, [(_vm.getMobile) ? _c('menu-mobile') : _vm._e(), _vm._v(" "), _c('header-comp'), _vm._v(" "), _c('router-view')], 1) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Bcm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @Plugin
 *
 * VueRoutes
 * Store id routes
 */

exports.default = {
  install: function install(Vue, options) {
    var store = options.store;

    store.commit('setRoutesId', options.routesId);
  }
};

/***/ }),

/***/ "8I+8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9kXo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _parallaxJs = __webpack_require__("BbWT");

var _parallaxJs2 = _interopRequireDefault(_parallaxJs);

var _scrollmonitor = __webpack_require__("E1Rp");

var _scrollmonitor2 = _interopRequireDefault(_scrollmonitor);

var _vueImgLoader = __webpack_require__("LOBr");

var _vueImgLoader2 = _interopRequireDefault(_vueImgLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'capsule-article',
	components: {
		VueImgLoader: _vueImgLoader2.default
	},
	props: ['contentData', 'propId'],
	data: function data() {
		return {
			isInViewport: false,
			transitionDuration: (Math.random() * (20 - 15) + 15) / 10,
			transitionDelay: Math.random() * 5 / 10,
			sceneId: 'capsuleArticle-' + this.propId,
			choiced: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		/*
  * Init parallax
  */
		if (!this.getMobile) {
			this.initParallax();
		}

		/*
  * Check if in viewport
  */
		var self = this;

		setTimeout(function () {
			var elementWatcher = _scrollmonitor2.default.create(self.$el);

			elementWatcher.enterViewport(function () {
				self.isInViewport = true;

				if (_this.parallax) {
					self.parallax.enable();
				}
			});

			elementWatcher.exitViewport(function () {
				self.isInViewport = false;

				if (_this.parallax) {
					self.parallax.disable();
				}
			});
		}, 0);
	},

	methods: {
		initParallax: function initParallax() {
			var scene = this.$refs.scene;
			this.parallax = new _parallaxJs2.default(scene, {
				hoverOnly: true,
				relativeInput: true,
				invertX: false,
				invertY: false
			});
		},
		isChoiced: function isChoiced() {
			this.choiced = true;
		}
	},
	watch: {
		getRouteLeave: function getRouteLeave(val) {
			if (val) {
				this.transitionDuration = this.transitionDuration / 2;
				this.transitionDelay = this.transitionDelay / 2;
			}
		},
		getViewport: function getViewport() {
			if (this.parallax && !this.getMobile) {
				this.parallax.destroy();

				this.initParallax();
			}
		}
	},
	computed: {
		getRouteLeave: function getRouteLeave() {
			return this.$store.getters.getRouteLeave;
		},
		getViewport: function getViewport() {
			return this.$store.getters.getViewport;
		},
		getMobile: function getMobile() {
			return this.$store.getters.getMobile;
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "AbW8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var state = {
  vwWidth: window.innerWidth,
  vwHeight: window.innerHeight,
  browser: null,
  smallDesktop: false,
  tablet: false,
  mobile: false,
  breakpoints: {
    desktop: 1200,
    tablet: 960,
    mobile: 680
  }

  /**
   * Getters
   */
};var getters = {
  getViewport: function getViewport(state) {
    return {
      width: state.vwWidth,
      height: state.vwHeight
    };
  },
  getBreakpoints: function getBreakpoints(state) {
    return state.breakpoints;
  },
  getSmallDesktop: function getSmallDesktop(state) {
    return state.smallDesktop;
  },
  getTablet: function getTablet(state) {
    return state.tablet;
  },
  getMobile: function getMobile(state) {
    return state.mobile;
  }

  /**
   * Actions
   */
};var actions = {
  checkViewport: function checkViewport(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (window.innerWidth <= state.breakpoints.desktop) {
      commit('setSmallDesktop', true);
    } else {
      commit('setSmallDesktop', false);
    }

    if (window.innerWidth <= state.breakpoints.tablet) {
      commit('setTablet', true);
    } else {
      commit('setTablet', false);
    }

    if (window.innerWidth <= state.breakpoints.mobile) {
      commit('setMobile', true);
    } else {
      commit('setMobile', false);
    }
  }
};

/**
 * Mutations
 */
var mutations = {
  setViewport: function setViewport(state, payload) {
    state.vwWidth = payload.width;
    state.vwHeight = payload.height;
  },
  setSmallDesktop: function setSmallDesktop(state, payload) {
    state.smallDesktop = payload;
  },
  setTablet: function setTablet(state, payload) {
    state.tablet = payload;
  },
  setMobile: function setMobile(state, payload) {
    state.mobile = payload;
  }
};

module.exports = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),

/***/ "CYj8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueViewport = {};

VueViewport.install = function (Vue, options) {
  var store = options.store;

  var size = {
    width: window.innerWidth,
    height: window.innerHeight
  };

  store.dispatch('checkViewport', size);

  window.addEventListener('resize', _lodash2.default.throttle(function () {
    var resize = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    store.dispatch('checkViewport', resize);
    store.commit('setViewport', resize);
  }, 100));
};

module.exports = VueViewport;

/***/ }),

/***/ "D0ZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("oPlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62fafe89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("moWF");
function injectStyle (ssrContext) {
  __webpack_require__("h+6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62fafe89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DMJd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//

exports.default = {
	name: 'article-view',
	props: ['contentData'],
	data: function data() {
		var struct = [3, 3, 2];
		var actualStruct = 0;

		var result = [];
		var lineCount = 0;

		for (var y = 0; y < this.contentData.body.length; y++) {
			if (!result[lineCount]) {
				result[lineCount] = [];
			}

			result[lineCount].push(this.contentData.body[y]);

			if (result[lineCount].length === struct[actualStruct]) {
				lineCount++;
				actualStruct++;

				if (actualStruct > 2) {
					actualStruct = 0;
				}
			}
		}

		return {
			articleLines: result,
			minHeight: this.$store.getters.getViewport.height
		};
	},

	watch: {
		getViewport: function getViewport(val) {
			this.minHeight = val.height;
		}
	},
	computed: {
		getMobile: function getMobile() {
			return this.$store.getters.getMobile;
		},
		getViewport: function getViewport() {
			return this.$store.getters.getViewport;
		}
	}
};

/***/ }),

/***/ "DNCy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DaQ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _scrollmonitor = __webpack_require__("E1Rp");

var _scrollmonitor2 = _interopRequireDefault(_scrollmonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'img-comp',
	props: ['heritedData'],
	data: function data() {
		return {
			isInViewport: false
		};
	},
	mounted: function mounted() {
		var self = this;

		setTimeout(function () {
			var elementWatcher = _scrollmonitor2.default.create(self.$el);

			elementWatcher.enterViewport(function () {
				self.isInViewport = true;
			});
		}, 0);
	}
}; //
//
//
//

/***/ }),

/***/ "Daod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "wrapper"
  }, [_c('div', [_c('logo'), _vm._v(" "), _c('menu-comp')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DfMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("pmbQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18af04df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("nLB5");
function injectStyle (ssrContext) {
  __webpack_require__("jZAH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18af04df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Fx8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn",
      "mode": "out-in"
    }
  }, [(_vm.contentData) ? _c('div', {
    key: _vm.dataReady,
    class: ['contact-content__container', _vm.getRouteLeave ? 'contact-content__container--leave' : '']
  }, [_c('div', {
    staticClass: "contact-content__text",
    style: ({
      minHeight: !_vm.getMobile && _vm.getViewport ? ((_vm.getViewport.height - 200 - 182) + "px") : '0'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contentData.body[0].content.rendered)
    }
  }), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GtF7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(Object.keys(_vm.articlesData).length > 0) ? _c('div', {
    key: _vm.dataReady,
    staticClass: "page-content__container"
  }, [_c('article-view', {
    attrs: {
      "content-data": _vm.articlesData
    }
  }), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gyfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: ['capsule-article', ("capsule-article--" + _vm.propId), _vm.isInViewport && !_vm.getRouteLeave ? 'capsule-article--appear' : '', _vm.choiced ? 'capsule-article--choiced' : ''],
    style: ({
      transitionDuration: (_vm.transitionDuration + "s"),
      transitionDelay: (_vm.transitionDelay + "s")
    })
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.contentData.slug))
    },
    nativeOn: {
      "click": function($event) {
        _vm.isChoiced($event)
      }
    }
  }, [_c('div', {
    staticClass: "capsule-article__img-container"
  }, [_c('div', {
    ref: "scene",
    staticClass: "capsule-article__scene"
  }, [_c('vue-img-loader', {
    attrs: {
      "data-depth": ".2",
      "preview": _vm.contentData.acf.main_picture_project.sizes.medium,
      "src": _vm.contentData.acf.main_picture_project.url,
      "transition": "fadeIn",
      "blur-preview": false
    }
  }, [_c('div', {
    staticClass: "capsule-article__spinner-container",
    attrs: {
      "data-depth": "0"
    }
  }, [_c('div', {
    staticClass: "capsule-article__spinner"
  })])])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "capsule-article__title-container",
    style: ({
      transitionDuration: (_vm.transitionDuration + "s"),
      transitionDelay: (_vm.transitionDelay + "s")
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.contentData.title.rendered))]), _vm._v(" "), (_vm.contentData.acf.customer_project) ? _c('span', {
    staticClass: "capsule-article__customer"
  }, [_vm._v(_vm._s(_vm.contentData.acf.customer_project))]) : _vm._e()])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ITVn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _common = __webpack_require__("/2az");

var _ContentType = __webpack_require__("cgov");

var _ContentType2 = _interopRequireDefault(_ContentType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'page-type',
	mixins: [_ContentType2.default],
	components: _common.common
};

/***/ }),

/***/ "Io8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuMobile_vue__ = __webpack_require__("aBEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuMobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuMobile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128025f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MenuMobile_vue__ = __webpack_require__("KNTy");
function injectStyle (ssrContext) {
  __webpack_require__("45KX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuMobile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128025f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MenuMobile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jmag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("l3B3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a6109f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("Daod");
function injectStyle (ssrContext) {
  __webpack_require__("DNCy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a6109f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KNTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['menu-mobile', _vm.getMenuState ? 'active' : '']
  }, [_c('ul', {
    staticClass: "niv-1"
  }, [_c('li', {
    class: [_vm.isHome ? 'active' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMenu($event)
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _vm._l((_vm.getMenuData.body.items), function(item, i) {
    return _c('li', {
      key: "item",
      class: [_vm.niv1Path === i + 1 ? 'active' : '', _vm.isHome && _vm.niv1Target === i + 1 ? 'active' : '', _vm.isHome && !_vm.niv1Target ? 'default' : '', _vm.getPostCategory === item.object_slug ? 'active' : '']
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.object_slug))
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeMenu($event)
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNm3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ManY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn",
      "mode": "out-in"
    }
  }, [(_vm.dataReady) ? _c('div', {
    key: _vm.dataReady,
    class: ['post-content__container', _vm.getRouteLeave ? 'post--leave' : '']
  }, [(_vm.contentData.content.rendered) ? _c('div', {
    staticClass: "post-content__content",
    style: ({
      maxWidth: _vm.contentData.acf.img_max_size ? ((_vm.contentData.acf.img_max_size) + "px") : '800px'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contentData.content.rendered)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-content__imgs",
    style: ({
      maxWidth: _vm.contentData.acf.img_max_size ? ((_vm.contentData.acf.img_max_size) + "px") : '800px'
    })
  }, _vm._l((10), function(n) {
    return (_vm.contentData.acf[("img_project_" + n)]) ? _c('image-comp', {
      key: "img",
      attrs: {
        "herited-data": _vm.contentData.acf[("img_project_" + n)]
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueAnalytics = __webpack_require__("AYPi");

var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);

var _App = __webpack_require__("j93H");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("/nV0");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("UjC2");

var _store2 = _interopRequireDefault(_store);

var _VueData = __webpack_require__("dWcL");

var _VueData2 = _interopRequireDefault(_VueData);

var _VueRoutes = __webpack_require__("6Bcm");

var _VueRoutes2 = _interopRequireDefault(_VueRoutes);

var _VueViewport = __webpack_require__("CYj8");

var _VueViewport2 = _interopRequireDefault(_VueViewport);

var _components = __webpack_require__("OZoh");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.use(_VueData2.default, { store: _store2.default });
_vue2.default.use(_VueViewport2.default, { store: _store2.default });
_vue2.default.use(_VueRoutes2.default, { store: _store2.default, routesId: _router2.default.ids });

_vue2.default.use(_vueAnalytics2.default, {
  id: 'UA-109756248-1',
  router: _router2.default.routes,
  checkDuplicatedScript: true
});

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default.routes,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default, components: _components.components }
});

/***/ }),

/***/ "NJC1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    class: ['img-comp', _vm.isInViewport ? 'img-comp--appear' : ''],
    attrs: {
      "src": _vm.heritedData.url,
      "alt": _vm.heritedData.title
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Npiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['menu', _vm.getMobile ? 'menu-burger__container' : '', _vm.getRouteLeave && !_vm.getMobile ? 'menu--leave' : ''],
    on: {
      "mouseleave": _vm.resetHover
    }
  }, [(!_vm.getMobile) ? _c('ul', {
    staticClass: "niv-1"
  }, _vm._l((_vm.getMenuData.body.items), function(item, i) {
    return _c('li', {
      key: "item",
      staticClass: "li-niv-1",
      class: [_vm.niv1Path === i + 1 ? 'active' : '', _vm.isHome && _vm.niv1Target === i + 1 ? 'active' : '', _vm.isHome && !_vm.niv1Target ? 'default' : '', _vm.getPostCategory === item.object_slug ? 'active' : ''],
      attrs: {
        "data-index": i + 1
      },
      on: {
        "mouseover": _vm.setHover
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.object_slug))
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('ul', {
      staticClass: "niv-2"
    }, _vm._l((item.children), function(subitem) {
      return _c('li', {
        key: "sub-item"
      }, [_c('router-link', {
        attrs: {
          "to": ("/" + (subitem.object_slug))
        }
      }, [_vm._v(_vm._s(subitem.title))])], 1)
    }))], 1)
  })) : _c('div', {
    class: ['burger-menu', _vm.menuOpen ? 'burger-menu--opened' : 'burger-menu--closed', _vm.getRouteLeave ? 'burger-menu--leave' : ''],
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OZoh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.components = undefined;

var _common = __webpack_require__("/2az");

var _contentType = __webpack_require__("y+r/");

var components = exports.components = {
	contentType: _contentType.contentType,
	common: _common.common
};

/***/ }),

/***/ "QvBn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rdlc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SDlF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Menu = __webpack_require__("0Y1p");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'menu-comp',
	mixins: [_Menu2.default],
	data: function data() {
		return {
			menuOpen: false
		};
	},

	methods: {
		setMenuState: function setMenuState() {
			this.menuOpen = !this.menuOpen;

			this.$store.commit('setMenuState', this.menuOpen);
		}
	},
	watch: {
		getMenuState: function getMenuState(val) {
			if (this.menuOpen !== val) {
				this.menuOpen = val;
			}
		}
	},
	computed: {
		getMobile: function getMobile() {
			return this.$store.getters.getMobile;
		},
		getMenuState: function getMenuState() {
			return this.$store.getters.getMenuState;
		},
		getRouteLeave: function getRouteLeave() {
			return this.$store.getters.getRouteLeave;
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Sntq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['logo', _vm.getMenuState && _vm.getMobile ? 'logo--disable' : '', _vm.getRouteLeave ? 'logo--leave' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', [_vm._v("LÉO ARNAUD")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UckQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__("/2az");

exports.default = {
  name: 'app',
  components: _common.common,
  data: function data() {
    this.get('menu', 'setMenuData');
    this.get('categories', 'setCategoriesData');

    return {
      dataReady: null
    };
  },

  methods: {
    checkData: function checkData() {
      if (this.getMenuData && this.getCategoriesData) {
        this.dataReady = 1;
      }
    },
    updateTitle: function updateTitle(pageTitle) {
      document.title = pageTitle;
    }
  },
  watch: {
    getMenuData: function getMenuData() {
      this.checkData();
    },
    getCategoriesData: function getCategoriesData() {
      this.checkData();
    },
    getPageTitle: function getPageTitle(title) {
      this.updateTitle(title);
    }
  },
  computed: {
    getMenuData: function getMenuData() {
      return this.$store.getters.getMenuData;
    },
    getCategoriesData: function getCategoriesData() {
      return this.$store.getters.getCategoriesData;
    },
    getMobile: function getMobile() {
      return this.$store.getters.getMobile;
    },
    getPageTitle: function getPageTitle() {
      return this.$store.getters.getPageTitle;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "UjC2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _data = __webpack_require__("f3zP");

var _data2 = _interopRequireDefault(_data);

var _device = __webpack_require__("AbW8");

var _device2 = _interopRequireDefault(_device);

var _routes = __webpack_require__("3heq");

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
		modules: {
				data: _data2.default,
				device: _device2.default,
				routes: _routes2.default
		}
});

/***/ }),

/***/ "W5Zx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//

exports.default = {
	name: 'logo',
	computed: {
		getMobile: function getMobile() {
			return this.$store.getters.getMobile;
		},
		getMenuState: function getMenuState() {
			return this.$store.getters.getMenuState;
		},
		getRouteLeave: function getRouteLeave() {
			return this.$store.getters.getRouteLeave;
		}
	}
};

/***/ }),

/***/ "X0se":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.heritedData) ? _c('div', {
    class: ['input-comp', _vm.value.length > 0 ? 'active' : '']
  }, [_c('label', {
    class: ['input-comp--label', _vm.value.length > 0 ? 'active' : '']
  }, [_vm._v(_vm._s(_vm.heritedData.label))]), _vm._v(" "), _c('label', {
    class: ['input-comp--placeholder', _vm.value.length > 0 ? 'active' : '', _vm.heritedData.type === 'textarea' ? 'input-comp--placeholder--text' : '']
  }, [_vm._v(_vm._s(_vm.heritedData.label))]), _vm._v(" "), (_vm.heritedData.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "email",
      "name": _vm.heritedData.name
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.heritedData.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "name": _vm.heritedData.name
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }) : _vm._e()]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XHCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("mwmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65303e3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("/5kN");
function injectStyle (ssrContext) {
  __webpack_require__("Rdlc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65303e3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Y1US":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-view",
    style: ({
      minHeight: !_vm.getMobile && _vm.getViewport ? ((_vm.getViewport.height - 230 - 182) + "px") : '0'
    })
  }, _vm._l((_vm.articleLines), function(line) {
    return (line.length > 0) ? _c('div', {
      staticClass: "article-view__line"
    }, _vm._l((line), function(item, index) {
      return _c('capsule-article', {
        key: "capsule",
        attrs: {
          "content-data": item,
          "propId": index
        }
      })
    })) : _vm._e()
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ydzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__("W5Zx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4f6b3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__("Sntq");
function injectStyle (ssrContext) {
  __webpack_require__("KNm3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4f6b3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aBEs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Menu = __webpack_require__("0Y1p");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'menu-mobile',
	mixins: [_Menu2.default],
	methods: {
		closeMenu: function closeMenu() {
			this.$store.commit('setMenuState', false);
		}
	},
	computed: {
		getMenuState: function getMenuState() {
			return this.$store.getters.getMenuState;
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "cSri":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _common = __webpack_require__("/2az");

var _ui = __webpack_require__("kqhr");

var _PageTitle = __webpack_require__("kpGF");

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _store = __webpack_require__("UjC2");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'contact',
	components: {
		common: _common.common,
		ui: _ui.ui
	},
	mixins: [_PageTitle2.default],
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		_store2.default.commit('setRouteLeave', false);
		next();
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		_store2.default.commit('setRouteLeave', true);

		setTimeout(function () {
			next();
		}, 1000);
	},
	created: function created() {
		this.fetchData();
	},
	data: function data() {
		return {
			contentData: null,
			routeName: this.$route.name,
			dataReady: false,
			minHeight: this.$store.getters.getViewport.height
		};
	},
	mounted: function mounted() {
		this.$store.commit('setPostCategory', null);
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.dispatchPageTitle('Contact');
			this.$store.commit('setPostCategory', null);

			if (!this.$store.getters.getContactData) {
				this.get('contact', 'setContactData', null).then(function (res) {
					_this.contentData = res;
					_this.dataReady = 1;
				});
			} else {
				var self = this;

				setTimeout(function () {
					self.contentData = self.$store.getters.getContactData;
					self.dataReady = 1;
				}, 500);
			}
		},
		submitForm: function submitForm() {
			this.$http.post('wp/v2/contact-api', {
				full_name: 'Anonyme',
				email: this.getFormData.email,
				phone: '0606060606',
				city: 'Anonyme',
				content: this.getFormData.content,
				token: 'e424cc23b4f93230eb84148598ec659d'
			}).then(function (res) {
				console.log(res);
			});
		}
	},
	watch: {
		getViewport: function getViewport(val) {
			this.minHeight = val.height;
		}
	},
	computed: {
		getFormData: function getFormData() {
			return this.$store.getters.getFormData;
		},
		getMobile: function getMobile() {
			return this.$store.getters.getMobile;
		},
		getViewport: function getViewport() {
			return this.$store.getters.getViewport;
		},
		getRouteLeave: function getRouteLeave() {
			return this.$store.getters.getRouteLeave;
		}
	}
};

/***/ }),

/***/ "cgov":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _store = __webpack_require__("UjC2");

var _store2 = _interopRequireDefault(_store);

var _PageTitle = __webpack_require__("kpGF");

var _PageTitle2 = _interopRequireDefault(_PageTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _route = null; /*
                   * Get content type ID
                   */

exports.default = {
	mixins: [_PageTitle2.default],
	created: function created() {
		if (_route) {
			this.fetchData();
		}
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		var slug = to.name;
		var routesID = _store2.default.getters.getRoutesId;

		var route = _lodash2.default.find(routesID, { slug: slug });

		if (route) {
			_route = route;

			_store2.default.commit('setRouteLeave', false);
			next();
		}
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		_store2.default.commit('setRouteLeave', true);

		setTimeout(function () {
			next();
		}, 500);
	},
	data: function data() {
		return {
			contentData: null,
			articlesData: {},
			routeName: this.$route.name,
			dataReady: false
		};
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.dataReady = 0;
			this.contentData = null;
			this.articlesData = {};

			this.routeName = this.$route.name;
			this.dispatchPageTitle(this.routeName);

			if (!this.$store.getters.getRouteWithID('r-' + _route['id'])) {
				this.get(_route['type'], null, _route['id']).then(function (res) {
					_this.$store.commit('setRoutesData', {
						key: 'r-' + _route['id'],
						value: res.body
					});

					_this.contentData = res.body;

					if (_route['type'] === 'post') {
						_this.setMenu();
					} else {
						_this.$store.commit('setPostCategory', null);
					}

					if (_this.contentData.acf.category_page !== 'none') {
						_this.get('post', null, null, _this.contentData.acf.category_page).then(function (res) {
							_this.articlesData = res;

							_this.$store.commit('setCategoriesContent', {
								key: _this.contentData.acf.category_page,
								value: res
							});

							_this.dataReady = 1;
						});
					} else {
						_this.dataReady = 1;
					}
				});
			} else {
				var self = this;

				setTimeout(function () {
					self.contentData = self.$store.getters.getRouteWithID('r-' + _route['id']);

					if (_route['type'] === 'post') {
						self.setMenu();
					} else {
						self.$store.commit('setPostCategory', null);
					}

					if (self.contentData.acf.category_page !== 'none') {
						/*
      * Fix reactivity
      */
						setTimeout(function () {
							self.articlesData = (0, _assign2.default)({}, self.articlesData, self.$store.getters.getCategorieContent(self.contentData.acf.category_page));
							self.dataReady = 1;
						}, 0);
					} else {
						self.dataReady = 1;
					}
				}, 800);
			}
		},
		updateTitle: function updateTitle() {}
	},
	watch: {
		'$route': 'fetchData'
	}
};

/***/ }),

/***/ "dWcL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__("ORbq");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueResource2.default); /**
                                           * @Plugin
                                           *
                                           * VueData
                                           * Defined many methods to use requests and manage Vuex Store
                                           */

_vue2.default.http.options.root = wp.root;

var urls = {
	menu: 'wp-api-menus/v2/menus/2',
	socials: 'wp-api-menus/v2/menus/9',
	categories: 'wp/v2/categories',
	page: 'wp/v2/pages',
	post: 'wp/v2/posts',
	postAll: 'wp/v2/posts/?per_page=100',
	contact: 'wp/v2/pages?slug=contact'
};

exports.default = {
	install: function install(Vue, options) {
		var store = options.store;

		/*
  *	Get Data
  */
		Vue.prototype.get = function (component, storeFunc, id, category) {
			var url = urls[component];

			if (id) {
				url = urls[component] + '/' + id;
			}

			if (category) {
				var cat = _lodash2.default.find(store.getters.getCategoriesData, { label: category });
				url = urls[component] + '?categories=' + cat.id + '&&per_page=100';
			}

			return Vue.http.get(url).then(function (response) {
				if (storeFunc) {
					store.commit(storeFunc, response);
				}

				return _promise2.default.resolve(response);
			}).catch(function (error) {
				return _promise2.default.reject(error);
			});
		};
	}
};

/***/ }),

/***/ "f3zP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Initial state
 */
var state = {
	menuData: null,
	categoriesData: null,
	categoriesContent: {},
	routesData: [],
	homeData: null,
	contactData: null,
	formData: {},
	menuState: false,
	footerData: false,
	postCategory: false

	/**
  * Getters
  */
};var getters = {
	getMenuData: function getMenuData(state) {
		return state.menuData;
	},
	getCategoriesData: function getCategoriesData(state) {
		return state.categoriesData;
	},
	getHomeData: function getHomeData(state) {
		return state.homeData;
	},
	getRoutesData: function getRoutesData(state) {
		return state.routesData;
	},
	getRouteWithID: function getRouteWithID(state) {
		return function (key) {
			return state.routesData[key];
		};
	},
	getCategorieContent: function getCategorieContent(state) {
		return function (key) {
			return state.categoriesContent[key];
		};
	},
	getAllCategoriesContent: function getAllCategoriesContent(state) {
		return state.categoriesContent;
	},
	getFormData: function getFormData(state) {
		return state.formData;
	},
	getMenuState: function getMenuState(state) {
		return state.menuState;
	},
	getFooterData: function getFooterData(state) {
		return state.footerData;
	},
	getPostCategory: function getPostCategory(state) {
		return state.postCategory;
	},
	getContactData: function getContactData(state) {
		return state.contactData;
	}

	/**
  * Actions
  */
};var actions = {};

/**
 * Mutations
 */
var mutations = {
	setMenuData: function setMenuData(state, payload) {
		state.menuData = payload;
	},
	setRoutesData: function setRoutesData(state, payload) {
		var processedData = state.routesData;
		processedData[payload.key] = payload.value;

		state.routesData = (0, _assign2.default)({}, processedData);
	},
	setHomeData: function setHomeData(state, payload) {
		state.homeData = payload;
	},
	setCategoriesData: function setCategoriesData(state, payload) {
		var categories = [];

		for (var y = 0; y < payload.body.length; y++) {
			var obj = {
				label: payload.body[y].slug,
				id: payload.body[y].id
			};

			categories.push(obj);
		}

		state.categoriesData = categories;
	},
	setCategoriesContent: function setCategoriesContent(state, payload) {
		state.categoriesContent[payload.key] = payload.value;
	},
	setFormData: function setFormData(state, payload) {
		var processedData = state.formData;
		processedData[payload.key] = payload.value;

		state.formData = (0, _assign2.default)({}, processedData);
	},
	setMenuState: function setMenuState(state, payload) {
		state.menuState = payload;
	},
	setFooterData: function setFooterData(state, payload) {
		state.footerData = payload;
	},
	setPostCategory: function setPostCategory(state, payload) {
		state.postCategory = payload;
	},
	setContactData: function setContactData(state, payload) {
		state.contactData = payload;
	}
};

module.exports = {
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
};

/***/ }),

/***/ "ge7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleView_vue__ = __webpack_require__("DMJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a139b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleView_vue__ = __webpack_require__("Y1US");
function injectStyle (ssrContext) {
  __webpack_require__("8I+8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a139b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleView_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "h+6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQp6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j93H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("UckQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2896c08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("4waZ");
function injectStyle (ssrContext) {
  __webpack_require__("vXC1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2896c08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jZAH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kpGF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	methods: {
		dispatchPageTitle: function dispatchPageTitle(title) {
			if (title) {
				var pageName = this.capitalize(title);
				var fullTitle = pageName + ' - ' + wp.site_name;

				this.$store.commit('setPageTitle', fullTitle);
			}
		},
		capitalize: function capitalize(word) {
			return word.charAt(0).toUpperCase() + word.slice(1);
		}
	}
};

/***/ }),

/***/ "kqhr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ui = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _InputComp = __webpack_require__("vRBi");

var _InputComp2 = _interopRequireDefault(_InputComp);

var _ImageComp = __webpack_require__("v7nl");

var _ImageComp2 = _interopRequireDefault(_ImageComp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Common
*/

var ui = {
	InputComp: _vue2.default.component('input-comp', _InputComp2.default),
	ImageComp: _vue2.default.component('image-comp', _ImageComp2.default)
};

exports.ui = ui;

/***/ }),

/***/ "l3B3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Logo = __webpack_require__("Ydzz");

var _Logo2 = _interopRequireDefault(_Logo);

var _Menu = __webpack_require__("l7Rc");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'header-comp',
	components: {
		Logo: _Logo2.default,
		MenuComp: _Menu2.default
	}
};

/***/ }),

/***/ "l7Rc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__("SDlF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7078c0f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__("Npiu");
function injectStyle (ssrContext) {
  __webpack_require__("nuYp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7078c0f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lyGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Capsule_vue__ = __webpack_require__("9kXo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Capsule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Capsule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e18cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Capsule_vue__ = __webpack_require__("Gyfz");
function injectStyle (ssrContext) {
  __webpack_require__("tmnL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Capsule_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e18cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Capsule_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "moWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mwmZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _common = __webpack_require__("/2az");

var _store = __webpack_require__("UjC2");

var _store2 = _interopRequireDefault(_store);

var _PageTitle = __webpack_require__("kpGF");

var _PageTitle2 = _interopRequireDefault(_PageTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'home',
	components: _common.common,
	mixins: [_PageTitle2.default],
	created: function created() {
		this.fetchData();
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		_store2.default.commit('setRouteLeave', false);
		next();
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		_store2.default.commit('setRouteLeave', true);

		setTimeout(function () {
			next();
		}, 1000);
	},
	data: function data() {
		return {
			contentData: null,
			articleLines: null,
			routeName: this.$route.name,
			dataReady: false
		};
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.dispatchPageTitle(wp.site_name);
			this.$store.commit('setPostCategory', null);

			if (!this.$store.getters.getHomeData) {
				this.get('postAll', 'setHomeData', null).then(function (res) {
					_this.contentData = res;
					_this.dataReady = 1;
				});
			} else {
				var self = this;

				setTimeout(function () {
					self.contentData = self.$store.getters.getHomeData;
					self.dataReady = 1;
				}, 500);
			}
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "nLB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getFooterData) ? _c('footer', {
    class: [_vm.getRouteLeave ? 'disable' : '']
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "socials"
  }, [_c('ul', _vm._l((_vm.getFooterData.body.items), function(link) {
    return _c('li', {
      key: "social"
    }, [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_c('i', {
      class: ("icon-" + (link.title))
    })])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("\n\t\t\tCopyright © All rights reserved.\n\t\t")])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nTJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__("ITVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95355828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__("GtF7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95355828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nW+/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'input-comp',
	props: ['heritedData'],
	data: function data() {
		return {
			value: ''
		};
	},

	watch: {
		value: function value() {
			this.$store.commit('setFormData', {
				key: this.heritedData.name,
				value: this.value
			});
		}
	}
};

/***/ }),

/***/ "nuYp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPlk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//

exports.default = {
	name: 'loader',
	props: ['label']
};

/***/ }),

/***/ "obqT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pmbQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'footer-comp',
	created: function created() {
		if (!this.$store.getters.getFooterData) {
			this.get('socials', 'setFooterData');
		}
	},

	computed: {
		getFooterData: function getFooterData() {
			return this.$store.getters.getFooterData;
		},
		getRouteLeave: function getRouteLeave() {
			return this.$store.getters.getRouteLeave;
		}
	}
};

/***/ }),

/***/ "rKIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t4rm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _common = __webpack_require__("/2az");

var _ui = __webpack_require__("kqhr");

var _ContentType = __webpack_require__("cgov");

var _ContentType2 = _interopRequireDefault(_ContentType);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'post-type',
	mixins: [_ContentType2.default],
	components: {
		common: _common.common,
		ui: _ui.ui
	},
	methods: {
		setMenu: function setMenu() {
			var cat = this.$store.getters.getCategoriesData;
			var catPost = this.contentData.categories[0];

			var catSlug = _lodash2.default.find(cat, function (el) {
				return el.id === catPost;
			});

			this.$store.commit('setPostCategory', catSlug.label);
		}
	},
	computed: {
		getRouteLeave: function getRouteLeave() {
			return this.$store.getters.getRouteLeave;
		}
	}
};

/***/ }),

/***/ "t5hd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("cSri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d735735a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("Fx8Y");
function injectStyle (ssrContext) {
  __webpack_require__("obqT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d735735a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tmnL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v7nl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageComp_vue__ = __webpack_require__("DaQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c89efa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ImageComp_vue__ = __webpack_require__("NJC1");
function injectStyle (ssrContext) {
  __webpack_require__("rKIY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageComp_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c89efa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ImageComp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vRBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputComp_vue__ = __webpack_require__("nW+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_888b001c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_InputComp_vue__ = __webpack_require__("X0se");
function injectStyle (ssrContext) {
  __webpack_require__("QvBn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputComp_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_888b001c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_InputComp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vXC1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+r/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentType = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _Home = __webpack_require__("XHCX");

var _Home2 = _interopRequireDefault(_Home);

var _Contact = __webpack_require__("t5hd");

var _Contact2 = _interopRequireDefault(_Contact);

var _Page = __webpack_require__("nTJ5");

var _Page2 = _interopRequireDefault(_Page);

var _Post = __webpack_require__("34s1");

var _Post2 = _interopRequireDefault(_Post);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Content type
*/

var contentType = {
  Home: _vue2.default.component('home', _Home2.default),
  Contact: _vue2.default.component('contact', _Contact2.default),
  PageType: _vue2.default.component('page-type', _Page2.default),
  PostType: _vue2.default.component('post-type', _Post2.default)
};

exports.contentType = contentType;

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// build/js/app.js